<template>
  <div class="sn-f-b-s homepage">
    <sn-navigator id="JKJT"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s homepage-region">
      <sn-breadcrumb :breadcrumb="[{ title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_ZJJT) }]"></sn-breadcrumb>
      <div class="sn-f-1 sn-f-s-1 homepage-blank">
        <el-form :model="query" :inline="true" label-position="left" class="form-region" @submit.native.prevent v-if="!lecturerId">
          <el-form-item label="科普分类">
            <el-select filterable v-model="query.first" style="width: 200px;" placeholder="请选择科普分类" @change="updateFirstCategories">
              <el-option v-for="first in firstCategories" :key="first.id" :label="first.name" :value="first.id"/>
            </el-select>
          </el-form-item>
          <el-form-item label="科室分类">
            <el-select filterable clearable v-model="query.second" style="width: 200px;" placeholder="请选择科室分类" @change="updateSecondCategories">
              <el-option v-for="second in secondCategories" :key="second.id" :label="second.name" :value="second.id"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="refreshSearch">查询</el-button>
            <el-button icon="el-icon-refresh-right" @click="resetParams">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="video-region" v-if="!$sn.validate.empty(handlePropagate)">
          <!-- 单项视频 -->
          <div class="sn-f-b-c single" v-for="(item, i) in handlePropagate" :key="item.id" :class="{'no-margin': (i + 1) % 3 === 0 }" @click="navigateUrl('/lecture/{0}', item)">
            <div class="sn-f-c-c propagate-image" :style="{'background-image': 'url(' + perpetual.ALI_CLOUD_DOMAIN_STATIC + item.cover + ')'}">
              <div class="iconfont icon-bofanganniu" v-if="['GENERAL', 'VIDEO'].includes(item.courseType) && item.cover"></div>
            </div>
            <div class="sn-f-col-b-s sn-f-1 lecture-secretary">
              <div>
                <div class="sn-omit title" v-if="item.title">{{item.title}}</div>
                <div class="sn-fs-14" v-if="item.lecturerName">讲师：{{ item.lecturerName }}</div>
              </div>
              <div class="sn-f-s-c end">
                <!-- <div class="play-icon" v-if="['GENERAL', 'VIDEO'].includes(item.courseType)"></div> -->
                <div class="sn-fs-12">{{['ARTICLE'].includes(item.courseType) ? '阅读' : '观看'}}{{item.viewerCount}}次</div>
              </div>
            </div>
          </div>
        </div>
        <sn-no-data v-else></sn-no-data>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第<span class="sn-fc-main sn-ph-10">{{ pageCount }}</span>页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(propagateInfo, pageSize)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';

export default {
  data() {
    return {
      perpetual: Constants,
      firstCategories: [], // 一级分类
      secondCategories: [], // 二级分类
      propagateInfo: [],
      locations: 'INDEX',
      query: {
        first: '',
        second: ''
      },
      lecturerId: '',
      pageCount: 1,
      isResult: true,
      pageSize: 9
    };
  },
  computed: {
    handlePropagate() {
      let handle = [];
      if (this.propagateInfo.length > 0) handle = this.$sn.format.group(this.propagateInfo, this.pageSize)[this.pageCount - 1];
      return handle;
    }
  },
  watch: {
    $route(val, old) {
      if ((old.path === '/lecture/homepage' && val.path !== '/lecture/homepage/article' && val.path !== '/lecture/homepage/video') ||
      (old.path === '/lecture/homepage/article' && old.path !== '/lecture/homepage/video' && val.path !== '/lecture/homepage') ||
      (old.path === '/lecture/homepage/video' && old.path !== '/lecture/homepage/article' && val.path !== '/lecture/homepage')) {
        this.initial();
      }
    },
    pageCount: {
      handler: function(n, o) {
        if ((n >= o || this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.propagateInfo, this.pageSize)[n])) {
          if (this.query.first && this.query.second) this.getInfo();
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.initial();
  },
  methods: {
    // 初始化
    initial() {
      document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_ZJJT);
      this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_ZJJT);
      this.pageCount = 1;
      this.query = { first: '', second: '' };
      this.locations = this.$route.query.locations || 'INDEX';
      this.lecturerId = this.$route.query.lecturerId || '';
      // INDEX=首页推荐，INFORMATION=资讯推荐，DOCTOR_INDEX=医生主页
      // 健康讲堂分类列表
      if (this.locations) {
        if (['INDEX', 'INFORMATION'].includes(this.locations)) this.getCategory(this.locations);
        else this.getInfo();
      }
      else this.getCategory('INDEX,INFORMATION,DOCTOR_INDEX');
    },
    // 获取分类
    getCategory(locations) {
      this.firstCategories = [];
      this.secondCategories = [];
      this.$sn.utils.ordinaryRequest({
        url: Swagger.getLectureCategory,
        query: {
          hosId: this.$sn.utils.getHospitalId(),
          locations: locations
        }
      }).then(result => {
        if (result && result.code === 0 && result.data && result.data.length > 0) {
          this.firstCategories = result.data;
          this.query.first = this.query.first || (this.firstCategories[0]?.id || '');
          this.query.second = this.query.second || (this.firstCategories[0]?.children[0]?.id || '');
          this.secondCategories = this.query.first && this.firstCategories.find(item => item.id === this.query.first) ? this.firstCategories.find(item => item.id === this.query.first).children : [];
          this.refreshSearch();
        }
      });
    },
    // 获取课程
    getInfo() {
      if (['INDEX', 'INFORMATION'].includes(this.locations)) {
        if (this.firstCategories.length === 0) return false;
      }
      if (!this.isResult) return false;
      let url = Swagger.getLectureGeneralInfo;
      const query = {
        pageNumber: this.pageCount - 1,
        pageSize: this.pageSize,
        hosId: this.$sn.utils.getHospitalId()
      };
      if (this.locations === 'DOCTOR_INDEX') {
        url = Swagger.getLectureDoctorInfo;
        query.lecturerId = this.lecturerId;
      }
      else query.categoryId = this.query.second;
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest({
        url: url,
        query: query
      }).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data && result.data.content && result.data.content.length > 0) {
          if (this.pageSize === result.data.totalElements) this.isResult = false;
          else this.isResult = result.data.content.length === this.pageSize;
          if (this.pageCount === 1) this.propagateInfo = result.data.content;
          else this.propagateInfo = this.propagateInfo.concat(result.data.content);
        }
        else this.isResult = false;
      });
    },
    // 切换一级分类
    updateFirstCategories(firstId) {
      const filter = this.firstCategories.find(item => item.id === firstId);
      this.secondCategories = filter && filter.children ? filter.children : [];
      this.query.first = firstId;
      this.query.second = filter && filter.children ? filter.children[0].id : '';
      if (this.query.first) this.refreshSearch();
    },
    // 切换二级分类
    updateSecondCategories(secondId) {
      this.query.second = secondId;
      if (this.query.second) this.refreshSearch();
    },
    // 重置参数
    resetParams() {
      this.query.first = '';
      this.query.second = '';
      this.pageCount = 1;
      this.initial();
    },
    // 查询
    refreshSearch() {
      if (this.$sn.validate.empty(this.query.first) || this.$sn.validate.empty(this.query.second)) {
        this.$sn.assembly.toast({
          caption: this.$sn.format.caption(Messages.C019, [this.$sn.validate.empty(this.query.first) ? '科普分类' : '科室分类'])
        });
        return false;
      }
      this.isResult = true;
      this.propagateInfo = [];
      this.pageCount = 1;
      this.getInfo();
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.propagateInfo, this.pageSize)[this.pageCount])) this.pageCount++;
      }
    },
    // 路由跳转
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '/lecture/{0}') {
        const url = {
          'GENERAL': '/lecture/homepage/video',
          'ARTICLE': '/lecture/homepage/article',
          'VIDEO': '/lecture/homepage/video'
        };
        this.navigateUrl(url[item.courseType], item, params = { id: item.id, courseType: item.courseType });
      }
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.homepage {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;

  &-region {
    overflow: hidden;
    height: 100%;

    .homepage-blank {
      overflow: hidden;
      width: 100%;
      padding: 20px 20px 0;

      .form-region {
        .el-button--primary {
          background-color: $main;
          color: $white;
          border: none;
        }

        .el-button--default {
          background-color: $white;
          color: $text1;
          border: 1px solid $border1;
        }
      }

      .video-region {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 10px; /* 设置行列间距 */
        width: 100%;
        margin: 0 auto;

        .single {
          @include fs(12);

          overflow: hidden;
          border: 2px solid $main;
          border-radius: 8px;
          padding: 10px;

          .propagate-image {
            height: 108px;
            width: 192px;
            border-radius: 8px;
            background-position: 100% 100%;
            background-size: 100% 100%;
            background-repeat: no-repeat;

            .iconfont {
              font-size: 40px;
              color: $white;
            }
          }

          .lecture-secretary {
            padding: 10px 0 10px 6px;
            height: 100%;
            color: $text3;

            .title {
              @include fs(16);

              font-weight: bold;
              color: $text1;
              white-space: normal;
              display: -webkit-box;
              margin-bottom: 4px;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
            }

            .end {
              .play-icon {
                position: relative;
                display: inline-block;
                width: 15px;
                height: 15px;
                margin-right: 4px;
                border-radius: 50%;
                cursor: pointer;
                overflow: hidden;

                &::before {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 3px;
                  transform: translate(50%, -50%);
                  width: 0;
                  height: 0;
                  border-style: solid;
                  border-width: 4px 0 4px 6px;
                  border-color: transparent transparent transparent $main; /* 设置图标颜色 */
                }

                &::after {
                  content: "";
                  position: absolute;
                  top: 50%;
                  left: 0;
                  transform: translate(0%, -50%);
                  width: 16px;
                  height: 16px;
                  border-radius: 50%;
                  border: 2px solid $main;
                }

                &:hover {
                  transform: scale(1.02); /* 鼠标悬停时放大图标 */
                }
              }
            }
          }
        }

        .no-margin {
          margin-right: 0;
        }
      }
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
